export const SET_USER_INFO = 'setUserInfo';
export const SET_TOKEN = 'setToken';



// WEBPACK FOOTER //
// ./src/store/mutations/type.js